import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";

export default class GemJr extends Phaser.GameObjects.Container
{
    constructor(scene, p, i, e)
    {
        super(scene);

        this.scene = scene;
        this.pCont = p;
        this.ind = i;
        this.isEnd = e;
        this.randInd = 0;

        this.pCont.add(this);
		
        this.createItem();
    }

    createItem()
    {
        this.glitterC = this.scene.add.container().setScale(.7);

        this.glitterB = ABCyaPhaser.Images.addImage(Phaser.Math.Between(-20, 20), Phaser.Math.Between(-20, 20), "SparkleLarge", this.glitterC);
        this.glitterS = ABCyaPhaser.Images.addImage(Phaser.Math.Between(-20, 20), Phaser.Math.Between(-20, 20), "SparkleSmall", this.glitterC);

        if(this.isEnd){
            this.body = ABCyaPhaser.Images.addImage(0, 0, "Gem"+String(this.ind+1), this);
        } else {
            this.body = ABCyaPhaser.Images.addImage(0, 0, "smallGem"+String(this.ind), this);
        }

        this.add(this.glitterC);

        this.glitter("inB");
        this.glitter("inS");
    }

    glitter(type){
        const randWait = Phaser.Math.Between(1000, 10000);

        if(type == "inB"){
            if(!this.glitterB.scene) return;

            this.glitterB.x = Phaser.Math.Between(-30, 30);
            this.glitterB.y = Phaser.Math.Between(-30, 30);
            this.glitterB.alpha = 0;

            this.glitterBTween = this.scene.tweens.timeline({
                targets: this.glitterB,
                ease:Phaser.Math.Easing.Linear,
                loop:-1,
                loopDelay:Phaser.Math.Between(1000, 10000),

                tweens: [
                    {delay:randWait, alpha:1, duration: 500},
                    {alpha:Phaser.Math.FloatBetween(.1, .5), duration: Phaser.Math.Between(500, 1000)},
                    {alpha:Phaser.Math.FloatBetween(.5, 1), duration: Phaser.Math.Between(500, 1000)},
                    {alpha:0, duration: 500},
                ]
            });
        }
        if(type == "inS"){
            if(!this.glitterS.scene) return;

            this.glitterS.y = Phaser.Math.Between(-30, 30);
            this.glitterS.y = Phaser.Math.Between(-30, 30);
            this.glitterS.alpha = 0;

            this.glitterSTween = this.scene.tweens.timeline({
                targets: this.glitterS,
                ease:Phaser.Math.Easing.Linear,
                loop:-1,
                loopDelay:Phaser.Math.Between(1000, 10000),

                tweens: [
                    {delay:randWait, alpha:1, duration: 500},
                    {alpha:Phaser.Math.FloatBetween(.1, .5), duration: Phaser.Math.Between(500, 1000)},
                    {alpha:Phaser.Math.FloatBetween(.5, 1), duration: Phaser.Math.Between(500, 1000)},
                    {alpha:0, duration: 500},
                ]
            });
        }
    };

    toggleMovement(type){
        if(this.glitterBTween) type ? this.glitterBTween.pause() : this.glitterBTween.resume();
        if(this.glitterSTween) type ? this.glitterSTween.pause() : this.glitterSTween.resume();
        type ? this.glitterC.visible = false : this.glitterC.visible = true;
    };

    stopMovement = function(){
        if(!this.scene) return;
        //stop the creatures tweens
        this.glitterBTween?.stop();
        this.glitterSTween?.stop();
        
        if(this.body) this.scene.tweens.killTweensOf(this.body);
        if(this.glitterB) this.scene.tweens.killTweensOf(this.glitterB);
        if(this.glitterS) this.scene.tweens.killTweensOf(this.glitterS);
    };

    destroyGem(){
        //Destroy the gem
        //console.log("DESTROYING");
        this.stopMovement();

        this.glitterC.removeAll(true);
        this.glitterC.destroy();

        this.removeAll(true);
        this.destroy();
    };
}